/**
 * SCR Motion — Zentraler Reveal Observer
 * Bindet alle [data-scr-reveal] und [data-scr-reveal-section] Elemente
 * an einen einzigen IntersectionObserver für Memory/Performance.
 */
/* Diagnose-Schalter: ?no-motion=1 an die URL haengen schaltet alle
   Scroll-Animationen ab (siehe scr-motion.css). Zum Eingrenzen von Ruckeln. */
(function () {
  try {
    if (location.search.indexOf('no-motion=1') >= 0) {
      document.documentElement.classList.add('scr-no-motion');
    }
  } catch (e) {}
})();

(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__scrMotionInit) return;
  window.__scrMotionInit = true;
  /* Bei abgeschalteter Motion gar nicht erst Observer aufsetzen */
  if (document.documentElement.classList.contains('scr-no-motion')) return;

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGGER_NORMAL = 90; // fallback if CSS var nicht greift

  /**
   * Reveal a section: set scr-revealed on the section + all children's
   * data-scr-reveal elements get their --scr-stagger-index ordered.
   */
  function revealSection(section) {
    var children = section.querySelectorAll('[data-scr-reveal]');
    children.forEach(function (el, i) {
      el.style.setProperty('--scr-stagger-index', i);
    });
    // Force reflow so transition-delay applies cleanly
    void section.offsetHeight;
    section.classList.add('scr-revealed');

    // Remove will-change after reveal completes (largest stagger + duration estimate)
    var totalMs = (children.length * STAGGER_NORMAL) + 1200;
    setTimeout(function () {
      children.forEach(function (el) {
        el.classList.add('scr-reveal-done');
      });
    }, totalMs);
  }

  function init() {
    var sections = document.querySelectorAll('[data-scr-reveal-section]:not([data-scr-bound])');
    if (!sections.length) return;

    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      sections.forEach(function (s) {
        s.setAttribute('data-scr-bound', '1');
        revealSection(s);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.18) {
          revealSection(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: [0, 0.18, 0.4],
      rootMargin: '0px 0px -8% 0px'
    });

    sections.forEach(function (s) {
      s.setAttribute('data-scr-bound', '1');
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Theme-Editor: rebind nach Section-Load */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-scr-bound]').forEach(function (s) {
        s.removeAttribute('data-scr-bound');
      });
      init();
    });
  }
})();

/**
 * SCR Motion PDP2 — geteilte Utilities für die cineastischen Produktseiten.
 * Alle Utilities sind Progressive Enhancement: ohne JS / bei reduced-motion
 * bleibt der Inhalt statisch SICHTBAR (nie unsichtbar hängen).
 *
 * 1) Pin-Szene:   [data-scr-pin] (hoher Wrapper) + innere .scr-pin__sticky.
 *                 JS schreibt --scr-pin-p (0..1) auf den Wrapper und setzt
 *                 data-scr-pin-stage="n" (1-basiert) wenn data-scr-pin-stages="N".
 * 2) Count-up:    [data-scr-count data-target="1620"] — HTML enthält bereits den
 *                 ENDWERT (Server-gerendert); JS animiert nur von 0 hoch.
 * 3) Callouts:    [data-scr-callout-group] Container; Kinder [data-scr-callout]
 *                 werden gestaffelt mit .scr-callout-in versehen.
 * 4) Video:       video[data-scr-video] — IO-gesteuertes play/pause, muted.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__scrMotionPdp2Init) return;
  window.__scrMotionPdp2Init = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  /* ---------- 1) Pin-Szene ---------- */
  var pins = [];
  function pinTick() {
    for (var i = 0; i < pins.length; i++) {
      var el = pins[i];
      var rect = el.getBoundingClientRect();
      var total = el.offsetHeight - window.innerHeight;
      if (total <= 0) continue;
      var p = Math.min(1, Math.max(0, -rect.top / total));
      el.style.setProperty('--scr-pin-p', p.toFixed(4));
      var stages = parseInt(el.getAttribute('data-scr-pin-stages') || '0', 10);
      if (stages > 1) {
        var stage = Math.min(stages, Math.floor(p * stages) + 1);
        if (el.getAttribute('data-scr-pin-stage') !== String(stage)) {
          el.setAttribute('data-scr-pin-stage', String(stage));
        }
      }
    }
  }
  var pinRaf = false;
  function onScrollPin() {
    if (pinRaf) return;
    pinRaf = true;
    requestAnimationFrame(function () { pinRaf = false; pinTick(); });
  }

  function initPins() {
    var found = document.querySelectorAll('[data-scr-pin]:not([data-scr-pin-bound])');
    if (!found.length) return;
    found.forEach(function (el) {
      el.setAttribute('data-scr-pin-bound', '1');
      if (REDUCED) { el.setAttribute('data-scr-pin-static', '1'); return; }
      el.classList.add('scr-pin-active');
      pins.push(el);
    });
    if (pins.length && !window.__scrPinScrollBound) {
      window.__scrPinScrollBound = true;
      window.addEventListener('scroll', onScrollPin, { passive: true });
      window.addEventListener('resize', onScrollPin, { passive: true });
      pinTick();
    }
  }

  /* ---------- 2) Count-up (de-DE, Endwert steht bereits im HTML) ---------- */
  function animateCount(el) {
    var raw = (el.getAttribute('data-target') || el.textContent || '0').toString().trim();
    var cleaned = raw.replace(/\./g, '').replace(',', '.');
    var target = parseFloat(cleaned);
    if (!isFinite(target)) return;
    var decimals = parseInt(el.getAttribute('data-decimals') || (raw.indexOf(',') >= 0 ? '1' : '0'), 10);
    var dur = parseInt(el.getAttribute('data-duration') || '1400', 10);
    var fmt = new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    var start = performance.now();
    function ease(t) { return 1 - Math.pow(1 - t, 4); }
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      el.textContent = fmt.format(target * ease(p));
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = fmt.format(target);
    }
    requestAnimationFrame(tick);
  }

  function initCounts() {
    var counts = document.querySelectorAll('[data-scr-count]:not([data-scr-count-bound])');
    if (!counts.length) return;
    counts.forEach(function (el) { el.setAttribute('data-scr-count-bound', '1'); });
    if (REDUCED || !HAS_IO) return; /* Endwert steht schon im HTML */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var delay = parseInt(e.target.getAttribute('data-delay') || '0', 10);
          (function (el) { setTimeout(function () { animateCount(el); }, delay); })(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    counts.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3) Stat-Callouts (Linien docken an Bauteilen an) ---------- */
  function initCallouts() {
    var groups = document.querySelectorAll('[data-scr-callout-group]:not([data-scr-co-bound])');
    if (!groups.length) return;
    groups.forEach(function (g) {
      g.setAttribute('data-scr-co-bound', '1');
      if (REDUCED || !HAS_IO) return; /* ohne JS/Motion: Callouts sichtbar (CSS-Default) */
      g.classList.add('scr-co-anim');
    });
    if (REDUCED || !HAS_IO) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var items = e.target.querySelectorAll('[data-scr-callout]');
          items.forEach(function (item, i) {
            (function (it) { setTimeout(function () { it.classList.add('scr-callout-in'); }, 350 + i * 260); })(item);
          });
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.45 });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---------- 4) Video-Interludes (autoplay im Viewport, sonst Pause) ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-scr-video]:not([data-scr-video-bound])');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.setAttribute('data-scr-video-bound', '1');
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
    });
    if (!HAS_IO) { vids.forEach(function (v) { try { v.play().catch(function(){}); } catch (e) {} }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.getAttribute('data-src') && !v.getAttribute('src')) { v.src = v.getAttribute('data-src'); }
          try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (err) {}
        } else {
          try { v.pause(); } catch (err) {}
        }
      });
    }, { threshold: 0.35, rootMargin: '20% 0px 20% 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- 5) FAILSAFE — Reveals duerfen NIE unsichtbar haengen ----------
     Der scroll-gescrubbte Zweig (animation-timeline: view()) startet bei
     opacity:0. Tickt die Timeline nicht (kein Compositing, Browser-Eigenheit,
     Rendering-Fehler), bliebe der Text dauerhaft unsichtbar. Dieser Waechter
     prueft Elemente, die sichtbar sein MUESSTEN (im oder oberhalb des
     Viewports) und schaltet im Zweifel global auf "alles sichtbar".        */
  function failsafeCheck() {
    if (document.documentElement.classList.contains('scr-motion-failsafe')) return true;
    var vh = window.innerHeight || 0;
    var els = document.querySelectorAll('[data-scr-reveal]');
    var stuck = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      if (r.height === 0 && r.width === 0) continue;
      /* Element ist durchgelaufen oder mittig im Bild -> muss sichtbar sein */
      if (r.top < vh * 0.75) {
        if (getComputedStyle(el).opacity === '0') stuck++;
      }
    }
    if (stuck > 0) {
      document.documentElement.classList.add('scr-motion-failsafe');
      return true;
    }
    return false;
  }

  function armFailsafe() {
    var checks = 0;
    var timer = setInterval(function () {
      checks++;
      if (failsafeCheck() || checks >= 8) clearInterval(timer);
    }, 1200);
    /* Auch nach echtem Scrollen einmal nachfassen */
    var onScrollOnce = function () {
      window.removeEventListener('scroll', onScrollOnce);
      setTimeout(failsafeCheck, 900);
    };
    window.addEventListener('scroll', onScrollOnce, { passive: true, once: true });
  }

  function initAll() {
    initPins();
    initCounts();
    initCallouts();
    initVideos();
    armFailsafe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-scr-pin-bound],[data-scr-count-bound],[data-scr-co-bound],[data-scr-video-bound]').forEach(function (el) {
        el.removeAttribute('data-scr-pin-bound');
        el.removeAttribute('data-scr-count-bound');
        el.removeAttribute('data-scr-co-bound');
        el.removeAttribute('data-scr-video-bound');
      });
      initAll();
    });
  }
})();
